import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [],
    imports: [
        CommonModule
    ]
})
export class MapconstantsModule {
    gisStoreName: string = 'gdpms';
    // gisStoreName : string = 'NEWRM_Training';
    // gisIP: string = 'https://cwmi.niti.gov.in';
    // gisIP: string = 'http://209.97.168.65';
    gisIP: string = 'https://gdpms.mowr.gov.in';

    // url:string='http://209.97.168.65/geoserver/nmcg/wms/';
    url:string='https://gdpms.mowr.gov.in/geoserver/gdpms/wms/';
    year = (new Date()).getFullYear().toString();
    PANE_LIST = [{
        
        name: 'tile',
        zindex: '390'
    }, {
        name: 'vectortile',
        zindex: '395'
    }, {
        name: 'india',
        zindex: '431'
    }, {
        name: 'state',
        zindex: '430'
    },
    {
        name: 'district',
        zindex: '432'
    },
    {
        name: 'state_highlight',
        zindex: '436'
    },
    {
        name: 'block',
        zindex: '405'
    },
    {
        name: 'basin',
        zindex: '403'
    },
    {
        name: 'subbasin',
        zindex: '404'
    },
    {
        name: 'circlemarkers',
        zindex: '601'
    },
    {
        name: 'rivers',
        zindex: '608'
    },
    {
        name: 'labels',
        zindex: '700'
    },
    {
        name: 'districts',
        zindex: '402'
    },
    {
        name: 'District',
        zindex: '435'
    }
    ];
    REGIONWISECOLORS = {
        "NORTH EASTERN AND HIMALAYAN": "rgb(53, 130, 106)",
        "NON HIMALAYAN": "rgb(55, 102, 158)",
        "UNION TERRITORIES": "rgb(224, 178, 8)"
    }
    AdminBasinLayersList = ["STATE", "DISTRICT", "BASIN", "SUBBASIN"];

    VIEW_LAYERS = {
        'ADMIN': ["STATE", "DISRICT"],
        'BASIN': ["BASIN", "SUBBASIN"],
        'River': ["INDIA"]
    };

    layer_list = [{
        "groupName": 'Admin Boundaries',
        "layerList": [
            {
                url: this.url,
                layerName: "gdpms:india_new",
                style: "gdpms:india_boundary",
                attribution: "",
                minZoom: 5,
                maxZoom: 12,
                pane: 'india',
                cql_filter: '1=1',
                type: 'WMS',
                name: 'India',
                displayName: "India Boundary",
                default_display: true
            },
            {
                url: this.url,
                layerName: "gdpms:states",
                style: "gdpms:state_boundary",
                attribution: "",
                minZoom: 5,
                maxZoom: 12,
                pane: 'state',
                cql_filter: '1=1',
                type: 'WMS',
                name: 'states',
                displayName: "State Boundary",
                default_display: false

            },
            {
                "displayName": "District Boundaries",
                "index": 1,
                "name": "DISTRICT",
                "visible": true,
                "default_select": true,
                "layeroptions_name": this.gisStoreName + ":districts",
                "layer_name": "DISTRICT",
                "layeroptions_pane": "district",
                "layeroptions_min_zoom": 4,
                "layeroptions_max_zoom": 12,
                "legend": "DISTRICT",
                "highlight_style": {
                    weight: 2,
                    color: "#000000",
                    fillOpacity: 0.02
                },
                "layerServiceType": "VECTOR1",
                // "url": this.gisIP + '/geoserver/NEWRM/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=NEWRM:iw_state&maxFeatures=5000000&outputFormat=application%2Fjson',
                "url": this.gisIP + '/geoserver/' + this.gisStoreName + '/gwc/service/wmts?layer=' + this.gisStoreName + ':districts&tilematrixset=EPSG:900913&Service=WMTS&Request=GetTile&Version=1.0.0&Format=application/x-protobuf;type=mapbox-vector&TileMatrix=EPSG:900913:{z}&TileCol={x}&TileRow={y}',
                "cql_filter": null,
                "type": "VECTOR1",
                "style": {
                    weight: 1,
                    color: "#000000",
                    fillOpacity: 0.02
                },
                keys: {
                    name: "name",
                    id: "uuid",
                    type: "DISTRICT",
                    loc_name: "name",
                    loc_uuid: "UUID",
                    view: "ADMIN",
                    pid: "p_uuid"
                },
                hasFormatting: true

            },
            // {
            //     url:this.url,
            //     layerName: "gdpms:districts",
            //     style :"gdpms:dist_boundary" ,
            //     attribution:"",
            //     minZoom : 5,
            //     maxZoom : 12,
            //     pane : 'india',
            //     cql_filter:'1=1',
            //     type:'WMS',
            //     name:'districts',
            //     displayName:"District Boundary",
            //     default_display:true
            // }
        ]
    },
    {
        "groupName": 'Basin Boundaries',
        "layerList": [
            {
                "displayName": "District Boundaries",
                "index": 1,
                "name": "DISTRICTBASIN",
                "visible": true,
                "default_select": true,
                "layeroptions_name": this.gisStoreName + ":district_basin",
                "layer_name": "DISTRICTBASIN",
                "layeroptions_pane": "districts",
                "layeroptions_min_zoom": 4,
                "layeroptions_max_zoom": 12,
                "legend": "DISTRICT",
                "highlight_style": {
                    weight: 2,
                    color: "#000000",
                    fillOpacity: 0.02
                },
                "layerServiceType": "VECTOR1",
                // "url": this.gisIP + '/geoserver/NEWRM/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=NEWRM:iw_state&maxFeatures=5000000&outputFormat=application%2Fjson',
                "url": this.gisIP + '/geoserver/' + this.gisStoreName + '/gwc/service/wmts?layer=' + this.gisStoreName + ':district_basin&tilematrixset=EPSG:900913&Service=WMTS&Request=GetTile&Version=1.0.0&Format=application/x-protobuf;type=mapbox-vector&TileMatrix=EPSG:900913:{z}&TileCol={x}&TileRow={y}',
                "cql_filter": null,
                "type": "VECTOR1",
                "style": {
                    weight: 1,
                    color: "#000000",
                    fillOpacity: 0.02
                },
                keys: {
                    name: "name",
                    id: "uuid",
                    type: "DISTRICT",
                    loc_name: "name",
                    loc_uuid: "UUID",
                    view: "ADMIN",
                    pid: "p_uuid"
                },
                hasFormatting: true

            },
            {
                url: this.url,
                layerName: "gdpms:ganga_basin",
                style: "gdpms:basin_boundary",
                attribution: "",
                minZoom: 5,
                maxZoom: 12,
                pane: 'basin',
                cql_filter: '1=1;1=1',
                type: 'WMS',
                name: 'ganga_basin',
                displayName: "Ganga Basin",
                default_display: true
            },
            // {
            //     url:this.url,
            //     layerName: "gdpms:world_view,gdpms:ganga_basin",
            //     style :"gdpms:vassar_world_boundary,gdpms:vassar_boundary_inverse" ,
            //     attribution:"",
            //     minZoom : 5,
            //     maxZoom : 12,
            //     pane : 'basin',
            //     cql_filter:'1=1;1=1',
            //     type:'WMS',
            //     name:'ganga_basin',
            //     displayName:"Ganga Basin",
            //     default_display:true
            // },
            {
                url: this.url,
                layerName: "gdpms:main_river_1_2",
                style: "gdpms:river",
                attribution: "",
                minZoom: 5,
                maxZoom: 12,
                pane: 'rivers',
                cql_filter: '1=1',
                type: 'WMS',
                name: 'ganga',
                displayName: "River",
                default_display: false
            }
        ]
    },
    {
        "groupName": 'District Attendance',
        "layerList": [

            {
                "displayName": "Meetings ",
                "index": 1,
                "name": "DISTRICT_ATTENDENCE",
                "visible": false,
                "default_select": true,
                "layeroptions_name": this.gisStoreName + ":districts",
                "layer_name": "DISTRICT_ATTENDENCE",
                "layeroptions_pane": "District",
                "layeroptions_min_zoom": 4,
                "layeroptions_max_zoom": 12,
                "legend": "DISTRICT_ATTENDENCE",
                "highlight_style": {
                    weight: 2,
                    color: "#000000",
                    fillOpacity: 0.02
                },
                "layerServiceType": "VECTOR2",
                // "url": this.gisIP + '/geoserver/NEWRM/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=NEWRM:iw_state&maxFeatures=5000000&outputFormat=application%2Fjson',
                "url": this.gisIP + '/geoserver/' + this.gisStoreName + '/gwc/service/wmts?layer=' + this.gisStoreName + ':districts_new&tilematrixset=EPSG:900913&Service=WMTS&Request=GetTile&Version=1.0.0&Format=application/x-protobuf;type=mapbox-vector&TileMatrix=EPSG:900913:{z}&TileCol={x}&TileRow={y}',
                "cql_filter": null,
                "type": "VECTOR2",
                "style": {
                    weight: 1,
                    color: "#000000",
                    fillOpacity: 0.02
                },
                keys: {
                    name: "name",
                    id: "uuid",
                    type: "DISTRICT",
                    loc_name: "name",
                    loc_uuid: "UUID",
                    view: "ADMIN",
                    pid: "p_uuid"
                },
                hasFormatting: true

            }
        ]
    }]

    GROUP_LIST = [
        // {
        //     "groupNameGeoJson": 'Base Layers',
        //     "layersList": [{
        //         "name": "OSM",
        //         "displayName": "Open Street Maps",
        //         "layerServiceType": "TILELAYER",
        //         "url": 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png',
        //         "attribution": 'Map data © OpenStreetMap contributors' + ' © ' + this.year + ' All rights reserved. Powered by <a target="_blank" href="http://vassarlabs.com/">Vassar Labs</a>',
        //         "default_select": true,
        //         "pane": 'tile',
        //         "opacity": 0.1
        //     }]
        // },

        {
            "groupNameGeoJson": 'Admin Boundaries',
            "layersList": [
                {
                    "displayName": "State Boundaries",
                    "index": 1,
                    "name": "STATE",
                    "visible": true,
                    "default_select": true,
                    "layeroptions_name": "NEWRM:final_data_cwmi",
                    "layer_name": "STATE",
                    "layeroptions_pane": "rivers",
                    "layeroptions_min_zoom": 4,
                    "layeroptions_max_zoom": 7,
                    "inputtype": "checkbox",
                    "highlight_style": {
                        weight: 2,
                        color: "#000000",
                        fillOpacity: 0.02
                    },
                    "layerServiceType": "VECTOR",
                    // "url": this.gisIP + '/geoserver/NEWRM/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=NEWRM:iw_state&maxFeatures=5000000&outputFormat=application%2Fjson',
                    "url": this.gisIP + '/geoserver/' + this.gisStoreName + '/gwc/service/wmts?layer=' + this.gisStoreName + ':final_data_cwmi&tilematrixset=EPSG:900913&Service=WMTS&Request=GetTile&Version=1.0.0&Format=application/x-protobuf;type=mapbox-vector&TileMatrix=EPSG:900913:{z}&TileCol={x}&TileRow={y}',
                    "cql_filter": "type=STATE",
                    "type": "VECTOR",
                    "style": {
                        weight: 2,
                        color: "#000000",
                        opacity: 1,
                        fillOpacity: 0.02
                    },
                    keys: {
                        name: "state_name",
                        id: "uuid",
                        type: "STATE",
                        loc_name: "name",
                        loc_uuid: "UUID",
                        view: "ADMIN",
                        pid: "uuid"
                    }
                },
                {
                    "displayName": "District Boundaries",
                    "index": 1,
                    "name": "DISTRICT",
                    "visible": true,
                    "default_select": true,
                    "layeroptions_name": "NEWRM:final_data_cwmi",
                    "layer_name": "DISTRICT",
                    "layeroptions_pane": "rivers",
                    "layeroptions_min_zoom": 6,
                    "layeroptions_max_zoom": 7,
                    "inputtype": "checkbox",
                    "highlight_style": {
                        weight: 1,
                        color: "#000000",
                        fillOpacity: 0.02
                    },
                    "layerServiceType": "VECTOR",
                    // "url": this.gisIP + '/geoserver/NEWRM/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=NEWRM:iw_state&maxFeatures=5000000&outputFormat=application%2Fjson',
                    "url": this.gisIP + '/geoserver/' + this.gisStoreName + '/gwc/service/wmts?layer=' + this.gisStoreName + ':final_data_cwmi&tilematrixset=EPSG:900913&Service=WMTS&Request=GetTile&Version=1.0.0&Format=application/x-protobuf;type=mapbox-vector&TileMatrix=EPSG:900913:{z}&TileCol={x}&TileRow={y}',
                    "cql_filter": "type=DISTRICT",
                    "type": "VECTOR",
                    "style": {
                        weight: 1,
                        color: "grey",
                        opacity: 0.5,
                        fillOpacity: 0.02
                    },
                    keys: {
                        name: "state_name",
                        id: "uuid",
                        type: "STATE",
                        loc_name: "name",
                        loc_uuid: "UUID",
                        view: "ADMIN",
                        pid: "uuid"
                    }
                },
                {
                    name: "District Labels",
                    // displayName: "Block Boundaries",
                    layerServiceType: "WMSLAYER",
                    url: 'https://cwmi.niti.gov.in/geoserver/NEWRM/wms/',
                    layerName: "NEWRM:final_data_cwmi",
                    pane: 'labels',
                    default_select: true,
                    minzoom: 6,
                    maxzoom: 12,
                    weight: 0.5,
                    color: "#ffffff",
                    fillOpacity: 1,
                    transparent: true,
                    highlightzoom: 7,
                    style: 'cwmi_ind_district_labels',
                    hidelayer: true,
                    cql_filter: "type='DISTRICT'&&parent_type='STATE'"

                }
                // {
                // "displayName": "District Boundaries",
                // "index":1,
                // "name":"DISTRICT",
                // "visible":true,
                // "default_select": true,
                // "layeroptions_name":"NEWRM:indgec_all_dist",
                // "layer_name" : "DISTRICT",
                // "layeroptions_pane":"district",
                // "layeroptions_min_zoom":7,
                // "layeroptions_max_zoom":9,
                // "highlight_style": {
                // weight: 2,
                // color: "#000000",
                // fillOpacity: 0.02
                // },
                // "layerServiceType": "VECTOR",
                // // "url": this.gisIP + '/geoserver/NEWRM/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=NEWRM:iw_state&maxFeatures=5000000&outputFormat=application%2Fjson',
                // "url" :this.gisIP+'/geoserver/'+this.gisStoreName+'/gwc/service/wmts?layer='+this.gisStoreName+':indgec_all_dist&tilematrixset=EPSG:900913&Service=WMTS&Request=GetTile&Version=1.0.0&Format=application/x-protobuf;type=mapbox-vector&TileMatrix=EPSG:900913:{z}&TileCol={x}&TileRow={y}',
                // "cql_filter":"type=STATE",
                // "type":"VECTOR",
                // "style": {
                // weight: 1,
                // color: "#000000",
                // fillOpacity: 0.02
                // },
                // keys: {
                // name: "name",
                // id: "uuid",
                // type: "DISTRICT",
                // loc_name: "name",
                // loc_uuid: "UUID",
                // view: "ADMIN",
                // pid: "p_uuid"
                // }
                // },

                // {
                // name: "Block",
                // displayName: "Block Boundaries",
                // layerServiceType: "WMSLAYER",
                // url: 'https://geoserver.vassarlabs.com/geoserver/NEWRM/wms/',
                // layerName: "NEWRM:indgec_all_mandal",
                // pane: 'block',
                // default_select: true,
                // minzoom: 3,
                // maxzoom: 12,
                // weight: 0.5,
                // color: "#ffffff",
                // fillOpacity: 1,
                // transparent: true,
                // highlightzoom: 7,

                // }

            ]
        },
        // {
        // "groupNameGeoJson": 'Basin Boundaries',
        // "layersList": [{
        // "displayName": "Basin Boundaries",
        // "index":1,
        // "name":"BASIN",
        // "visible":false,
        // "default_select": false,
        // "layeroptions_name":"NEWRM:iw_basin",
        // "layer_name" : "BASIN",
        // "layeroptions_pane":"basin",
        // "layeroptions_min_zoom":4,
        // "layeroptions_max_zoom":12,
        // "highlight_style": {
        // weight: 2,
        // color: "#000000",
        // fillOpacity: 0.02
        // },
        // "layerServiceType": "VECTOR",
        // // "url": this.gisIP + '/geoserver/NEWRM/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=NEWRM:iw_state&maxFeatures=5000000&outputFormat=application%2Fjson',
        // "url" :this.gisIP+'/geoserver/'+this.gisStoreName+'/gwc/service/wmts?layer='+this.gisStoreName+':iw_basin&tilematrixset=EPSG:900913&Service=WMTS&Request=GetTile&Version=1.0.0&Format=application/x-protobuf;type=mapbox-vector&TileMatrix=EPSG:900913:{z}&TileCol={x}&TileRow={y}',
        // "cql_filter":"type=STATE",
        // "type":"VECTOR",
        // "style": {
        // weight: 1,
        // color: "#000000",
        // fillOpacity: 0.02
        // },
        // keys: {
        // name: "ba_name",
        // id: "uuid",
        // type: "BASIN",
        // loc_name: "BA_NAME",
        // loc_uuid: "UUID",
        // view: "BASIN",
        // pid: "uuid"
        // }
        // },
        // {
        // "displayName": "SubBasin Boundaries",
        // "index":1,
        // "name":"SUBBASIN",
        // "visible":false,
        // "default_select": false,
        // "layeroptions_name":"NEWRM:iw_subbasin",
        // "layer_name" : "SUBBASIN",
        // "layeroptions_pane":"subbasin",
        // "layeroptions_min_zoom":7,
        // "layeroptions_max_zoom":12,
        // "highlight_style": {
        // weight: 2,
        // color: "#000000",
        // fillOpacity: 0.02
        // },
        // "layerServiceType": "VECTOR",
        // // "url": this.gisIP + '/geoserver/NEWRM/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=NEWRM:iw_state&maxFeatures=5000000&outputFormat=application%2Fjson',
        // "url" :this.gisIP+'/geoserver/'+this.gisStoreName+'/gwc/service/wmts?layer='+this.gisStoreName+':iw_subbasin&tilematrixset=EPSG:900913&Service=WMTS&Request=GetTile&Version=1.0.0&Format=application/x-protobuf;type=mapbox-vector&TileMatrix=EPSG:900913:{z}&TileCol={x}&TileRow={y}',
        // "cql_filter":"type=STATE",
        // "type":"VECTOR",
        // "style": {
        // weight: 1,
        // color: "#000000",
        // fillOpacity: 0.02
        // },
        // keys: {
        // name: "sub_basin",
        // id: "uuid",
        // type: "SUBBASIN",
        // loc_name: "SUB_BASIN",
        // loc_uuid: "UUID",
        // view: "BASIN",
        // pid: "p_uuid"
        // }
        // },
        // ]
        // },
        {
            "groupNameGeoJson": 'Heatmap',
            "layersList": [
                {
                    "displayName": "Categorization of states",
                    "index": 2,
                    "name": "STATES_CATEGORIZATION",
                    "visible": false,
                    "default_select": false,
                    "layeroptions_name": "NEWRM:final_data_cwmi",
                    "layer_name": "STATES_CATEGORIZATION",
                    "layeroptions_pane": "rivers",
                    "layeroptions_min_zoom": 4,
                    "layeroptions_max_zoom": 12,
                    "inputtype": "radio",
                    "highlight_style": {
                        weight: 2,
                        color: "#000000",
                        fillOpacity: 0.02
                    },
                    "layerServiceType": "VECTOR",
                    // "url": this.gisIP + '/geoserver/NEWRM/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=NEWRM:iw_state&maxFeatures=5000000&outputFormat=application%2Fjson',
                    "url": this.gisIP + '/geoserver/' + this.gisStoreName + '/gwc/service/wmts?layer=' + this.gisStoreName + ':final_data_cwmi&tilematrixset=EPSG:900913&Service=WMTS&Request=GetTile&Version=1.0.0&Format=application/x-protobuf;type=mapbox-vector&TileMatrix=EPSG:900913:{z}&TileCol={x}&TileRow={y}',
                    "cql_filter": "type=STATE",
                    "type": "VECTOR",
                    "style": {
                        weight: 2,
                        color: "#000000",
                        opacity: 1,
                        fillOpacity: 0.02
                    },
                    keys: {
                        // name: "state_name",
                        // id: "uuid",
                        // type: "STATE",
                        // loc_name: "name",
                        // loc_uuid: "UUID",
                        // view: "ADMIN",
                        // pid: "uuid"
                    }
                },
                {
                    "displayName": "Categorization of districts",
                    "index": 2,
                    "name": "DISTRICTS_CATEGORIZATION",
                    "visible": false,
                    "default_select": false,
                    "layeroptions_name": "NEWRM:final_data_cwmi",
                    "layer_name": "DISTRICTS_CATEGORIZATION",
                    "layeroptions_pane": "rivers",
                    "layeroptions_min_zoom": 4,
                    "layeroptions_max_zoom": 12,
                    "inputtype": "radio",
                    "highlight_style": {
                        weight: 1,
                        color: "grey",
                        fillOpacity: 0.02
                    },
                    "layerServiceType": "VECTOR",
                    // "url": this.gisIP + '/geoserver/NEWRM/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=NEWRM:iw_state&maxFeatures=5000000&outputFormat=application%2Fjson',
                    "url": this.gisIP + '/geoserver/' + this.gisStoreName + '/gwc/service/wmts?layer=' + this.gisStoreName + ':final_data_cwmi&tilematrixset=EPSG:900913&Service=WMTS&Request=GetTile&Version=1.0.0&Format=application/x-protobuf;type=mapbox-vector&TileMatrix=EPSG:900913:{z}&TileCol={x}&TileRow={y}',
                    "cql_filter": "type=STATE",
                    "type": "VECTOR",
                    "style": {
                        weight: 1,
                        color: "grey",
                        opacity: 0.5,
                        fillOpacity: 0.02
                    },
                    keys: {
                        // name: "state_name",
                        // id: "uuid",
                        // type: "STATE",
                        // loc_name: "name",
                        // loc_uuid: "UUID",
                        // view: "ADMIN",
                        // pid: "uuid"
                    }
                },
                {
                    "displayName": "States performing on water resource management",
                    "index": 2,
                    "name": "STATES_PERFORMING",
                    "visible": true,
                    "default_select": true,
                    "layeroptions_name": "NEWRM:final_data_cwmi",
                    "layer_name": "STATES_PERFORMING",
                    "layeroptions_pane": "rivers",
                    "layeroptions_min_zoom": 4,
                    "layeroptions_max_zoom": 12,
                    "inputtype": "radio",
                    "highlight_style": {
                        weight: 2,
                        color: "#000000",
                        fillOpacity: 0.02
                    },
                    "layerServiceType": "VECTOR",
                    // "url": this.gisIP + '/geoserver/NEWRM/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=NEWRM:iw_state&maxFeatures=5000000&outputFormat=application%2Fjson',
                    "url": this.gisIP + '/geoserver/' + this.gisStoreName + '/gwc/service/wmts?layer=' + this.gisStoreName + ':final_data_cwmi&tilematrixset=EPSG:900913&Service=WMTS&Request=GetTile&Version=1.0.0&Format=application/x-protobuf;type=mapbox-vector&TileMatrix=EPSG:900913:{z}&TileCol={x}&TileRow={y}',
                    "cql_filter": "type=STATE",
                    "type": "VECTOR",
                    "style": {
                        weight: 2,
                        color: "#000000",
                        opacity: 1,
                        fillOpacity: 0.02
                    },
                    keys: {
                        // name: "state_name",
                        // id: "uuid",
                        // type: "STATE",
                        // loc_name: "name",
                        // loc_uuid: "UUID",
                        // view: "ADMIN",
                        // pid: "uuid"
                    }
                },
                {
                    "displayName": "Districts performing on water resource management",
                    "index": 2,
                    "name": "DISTRICTS_PERFORMING",
                    "visible": true,
                    "default_select": false,
                    "layeroptions_name": "NEWRM:final_data_cwmi",
                    "layer_name": "DISTRICTS_PERFORMING",
                    "layeroptions_pane": "rivers",
                    "layeroptions_min_zoom": 4,
                    "layeroptions_max_zoom": 12,
                    "inputtype": "radio",
                    "highlight_style": {
                        weight: 1,
                        color: "grey",
                        fillOpacity: 0.02
                    },
                    "layerServiceType": "VECTOR",
                    // "url": this.gisIP + '/geoserver/NEWRM/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=NEWRM:iw_state&maxFeatures=5000000&outputFormat=application%2Fjson',
                    "url": this.gisIP + '/geoserver/' + this.gisStoreName + '/gwc/service/wmts?layer=' + this.gisStoreName + ':final_data_cwmi&tilematrixset=EPSG:900913&Service=WMTS&Request=GetTile&Version=1.0.0&Format=application/x-protobuf;type=mapbox-vector&TileMatrix=EPSG:900913:{z}&TileCol={x}&TileRow={y}',
                    "cql_filter": "type=STATE",
                    "type": "VECTOR",
                    "style": {
                        weight: 2,
                        color: "#000000",
                        opacity: 0.5,
                        fillOpacity: 0.02
                    },
                    keys: {
                        // name: "state_name",
                        // id: "uuid",
                        // type: "STATE",
                        // loc_name: "name",
                        // loc_uuid: "UUID",
                        // view: "ADMIN",
                        // pid: "uuid"
                    }
                },

            ]
        }


    ];
    locationToZoomlevelMap = {
        STATE: 7,
        DISTRICT: 9,
        BASIN: 6,
        SUBBASIN: 8,
        BLOCK: 10
    }
    VECTORLAYER_CONSTANTS = {
        category: [
            {
                "index": 1,
                "name": "mandal",
                "visible": false,
                "layeroptions_name": "NEWRM:indgec_all_mandal",
                "layer_name": "category_mandal",
                "layeroptions_pane": "block",
                "layeroptions_min_zoom": 4,
                "layeroptions_max_zoom": 12,
                // "layeroptions_show_on_selector":true,
                "cql_filter": "type=STATE",
                "type": "VECTOR",
                // "subgroup_name":null,
                // "icon_name":null,
                "style": null,
                "nearme": null,
                "popup_template": null,
                "cache": false,
                "filter_style": null,
                "application_type": null,
                "visible_application": null,
                "layer_from": "geoserver",
                "basemap_type": null,
                "zoom_filter": null,
                "legend_display": false
            }
        ],
        rainfall: [
            {
                "index": 1,
                "name": "mandal",
                "visible": false,
                "layeroptions_name": "NEWRM:indgec_all_mandal",
                "layer_name": "rainfall_mandal",
                "layeroptions_pane": "block",
                "layeroptions_min_zoom": 5,
                "layeroptions_max_zoom": 12,
                // "layeroptions_show_on_selector":true,
                "cql_filter": "type=STATE",
                "type": "VECTOR",
                // "subgroup_name":null,
                // "icon_name":null,
                "style": null,
                "nearme": null,
                "popup_template": null,
                "cache": false,
                "filter_style": null,
                "application_type": null,
                "visible_application": null,
                "layer_from": "geoserver",
                "basemap_type": null,
                "zoom_filter": null,
                "legend_display": false
            }
        ],
        recharge: [
            {
                "index": 1,
                "name": "mandal",
                "visible": false,
                "layeroptions_name": "NEWRM:indgec_all_mandal",
                "layer_name": "recharge_mandal",
                "layeroptions_pane": "block",
                "layeroptions_min_zoom": 5,
                "layeroptions_max_zoom": 12,
                // "layeroptions_show_on_selector":true,
                "cql_filter": "type=STATE",
                "type": "VECTOR",
                // "subgroup_name":null,
                // "icon_name":null,
                "style": null,
                "nearme": null,
                "popup_template": null,
                "cache": false,
                "filter_style": null,
                "application_type": null,
                "visible_application": null,
                "layer_from": "geoserver",
                "basemap_type": null,
                "zoom_filter": null,
                "legend_display": false
            }
        ],
        draft: [
            {
                "index": 1,
                "name": "mandal",
                "visible": false,
                "layeroptions_name": "NEWRM:indgec_all_mandal",
                "layer_name": "draft_mandal",
                "layeroptions_pane": "block",
                "layeroptions_min_zoom": 5,
                "layeroptions_max_zoom": 12,
                // "layeroptions_show_on_selector":true,
                "cql_filter": "type=STATE",
                "type": "VECTOR",
                // "subgroup_name":null,
                // "icon_name":null,
                "style": null,
                "nearme": null,
                "popup_template": null,
                "cache": false,
                "filter_style": null,
                "application_type": null,
                "visible_application": null,
                "layer_from": "geoserver",
                "basemap_type": null,
                "zoom_filter": null,
                "legend_display": false
            }
        ],
        login: [
            {
                "index": 1,
                "name": "mandal",
                "visible": false,
                "layeroptions_name": "NEWRM:indgec_chatis_mandal",
                "layer_name": "login_mandal",
                "layeroptions_pane": "block",
                "layeroptions_min_zoom": 5,
                "layeroptions_max_zoom": 12,
                // "layeroptions_show_on_selector":true,
                "cql_filter": "type=STATE",
                "type": "VECTOR",
                // "subgroup_name":null,
                // "icon_name":null,
                "style": null,
                "nearme": null,
                "popup_template": null,
                "cache": false,
                "filter_style": null,
                "application_type": null,
                "visible_application": null,
                "layer_from": "geoserver",
                "basemap_type": null,
                "zoom_filter": null,
                "legend_display": false
            }
        ],
    };


    LEGEND_DATA = {
        "DISTRICT_ATTENDENCE": {
            "title": "Districts performing",
            "levels": [{
                "color": "#50C878",
                "name": "High (Meetings: >99%)"
            },
            {
                "color": "#FFFF00",
                "name": "Medium (Meetings: 50% to 99%)"
            },
            {
                "color": "#FF7F50",
                "name": "Low (Meetings:1% to 49.99%)"
            },
            {
                "color": "#808080",
                "name": "No data available"
            },
            {
                "color": "#8B0000",
                "name": "No meetings held(Meetings:0%)"
            }]

            // }
        },
        "DISTRICT": {
            "title": "District categorization",
            "levels": [
                {
                    "color": "#FBF8F3",
                    "name": "District with out DGC"
                },
                {
                    "color": "#90EE90",
                    "name": "Tributary District DGC"
                },
                {
                    "color": "#006400",
                    "name": "Main Stem District DGC"
                }]
        }
    }
    specificLang: string;
}

